<template>
  <el-container class="branch-outstanding-pass pagination-list">
    <el-main>
      <div class="content">
        <el-col :span="22" class="branch-outstanding-pass-search">
          <el-form>
            <el-form-item label="起始时间:" label-width="80px">
              <el-date-picker v-model="searchParams.startTime" value-format="yyyy-MM-dd" type="month"></el-date-picker>
            </el-form-item>

            <el-form-item label="终止时间:" label-width="80px">
              <el-date-picker v-model="searchParams.endTime" value-format="yyyy-MM-dd" type="month"></el-date-picker>
            </el-form-item>

            <el-form-item label="所属分公司" label-width="80px">
              <el-input :title="filiale" v-model="filiale" placeholder="请选择分公司" readonly @click.native.prevent="openDialog"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button @click="search" size="mini">生成</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <div class="echarts-bar-line" ref="echartsBarLine"></div>
        <select-filiale-dialog
          :dialogVisible="dialogVisible"
          :selectType="selectType"
          @setFiliale="setFiliale"
          @setSelectList="setSelectList"
          @closeDialog="closeDialog"></select-filiale-dialog>
        <div class="text" v-show="textData.length !== 0">
          <p v-for="(text,index) in textData" :key="index">
            {{text.month}}份全国各分公司共计合作店（有驻店）{{text.generalCount}}家，{{text.month.substr(-3)}}月份有出单的合作店共计{{text.orderCount}}家，占比{{text.rate * 100}}%。
            其中月出单21单及以上的共计{{text.data.third}}家，出单11-20单的共计{{text.data.second}}家，出单10单及以下的共计{{text.data.first}}家。
          </p>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import SelectFilialeDialog from './publicDialog/select-filiale-dialog.vue'
import Vue from 'vue'
let echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/line')
require('echarts/lib/component/tooltip')
Vue.use(echarts)
export default {
  name: 'branch-outstanding-pass',
  components: {SelectFilialeDialog},
  data () {
    return {
      selectType: 'single',
      dialogVisible: false,
      // 已选分公司
      selectList: [],
      searchParams: {
        startTime: moment().subtract(30, 'days').format('YYYY-MM-01'),
        endTime: moment().format('YYYY-MM-01')
      },
      filiale: '',
      textData: []
    }
  },
  mounted () {
    this.drawEcharts()
    // 监听窗口大小变化重绘echarts
    window.onresize = _.debounce(() => {
      let myCharts = echarts.init(this.$refs.echartsBarLine)
      myCharts.resize()
    }, 100)
  },
  methods: {
    drawEcharts () {
      let myCharts = echarts.init(this.$refs.echartsBarLine)
      myCharts.setOption({
        title: {
          text: '分公司优秀及合格店数量',
          textStyle: {
            color: '#2A2929',
            fontSize: 20
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            snap: 'true'
          }
        },
        grid: {
          bottom: 80
        },
        legend: {
          bottom: 30,
          itemGap: 100,
          data: [
            {
              name: '0-10单合作商数量'
            },
            {
              name: '11-20单合作商数量'
            },
            {
              name: '21单以上合作商数量'
            }]
        },
        xAxis: {
          type: 'category'
        },
        yAxis: {
          minInterval: 1
        },
        series: [
          {
            name: '0-10单合作商数量',
            type: 'line',
            itemStyle: {
              color: '#4F81BD'
            }
          },
          {
            name: '11-20单合作商数量',
            type: 'line',
            itemStyle: {
              color: '#A59A60'
            }
          },
          {
            name: '21单以上合作商数量',
            type: 'line',
            itemStyle: {
              color: '#C0504D'
            }
          }
        ]
      })
    },
    openDialog () {
      this.dialogVisible = true
    },
    // 当前选中分公司
    setFiliale (filiale) {
      this.filiale = filiale
    },
    setSelectList (selectList) {
      this.selectList = selectList
      this.dialogVisible = false
    },
    closeDialog () {
      this.dialogVisible = false
    },
    search () {
      if (!this.searchParams.startTime) {
        return this.$message.error('请选择起始时间')
      }
      if (!this.searchParams.endTime) {
        return this.$message.error('请选择终止时间')
      }
      if (new Date(this.searchParams.startTime).getTime() > new Date(this.searchParams.endTime).getTime()) {
        return this.$message.error('起始时间不能大于终止时间')
      }
      if (this.selectList.length === 0) {
        return this.$message.error('请选择分公司')
      }
      this.textData = []
      let companyId = this.selectList.map(e => e.id).join()
      if (companyId === '0005A41F-0000-0000-0000-0000FDA5314A') {
        companyId = ''
      }
      let data = {
        startDate: this.searchParams.startTime,
        endDate: this.searchParams.endTime,
        companyId: companyId
      }
      let myCharts = echarts.init(this.$refs.echartsBarLine)
      myCharts.showLoading({
        text: '加载中...',
        color: '#47A2FF',
        textColor: '#47A2FF',
        maskColor: 'rgba(255, 255, 255, 0.8)',
        zlevel: 0
      })
      this.$axios.post('/huaao-api/visualReport/getMonthCount', data).then(res => {
        let echartsData = res.data.data
        res.data.textData.forEach(item => {
          this.textData.push({month: moment(item.date).format('YYYY年MM月'), generalCount: item.generalCount ? item.generalCount : 0, orderCount: item.orderCount ? item.orderCount : 0, rate: item.rate, data: item})
        })
        let xAxisData = []
        let lineYAxis1 = [] // 0-10
        let lineYAxis2 = [] // 11-20
        let lineYAxis3 = [] // 21以上
        // 设置x轴及折线图数据
        echartsData.forEach(item => {
          xAxisData.push(item.date)
          lineYAxis1.push(item.first)
          lineYAxis2.push(item.second)
          lineYAxis3.push(item.third)
        })
        myCharts.setOption({
          xAxis: {
            data: xAxisData
          },
          series: [
            {
              data: lineYAxis1
            },
            {
              data: lineYAxis2
            },
            {
              data: lineYAxis3
            }
          ]
        })
        myCharts.hideLoading()
      }).catch(() => {
        myCharts.hideLoading()
      })
    }
  }
}
</script>

<style lang="scss">
  @import "@/assets/scss/common.scss";

  .el-container.branch-outstanding-pass {
    .content {
      height: calc(100% - 80px);

      .branch-outstanding-pass-search {
        .el-form {
          display: flex;
          flex-wrap: nowrap;
          overflow-x: scroll;
          height: 46px;
          .el-form-item{
             flex: 0 1 auto;
           }
          .el-form-item:nth-of-type(4){
            margin-left: 10px;
          }
          .el-form-item:last-of-type{
            margin-left: 50px;
          }
        }
        .el-button{
          padding: 4px 10px;
          border-color: #55ACF1;
          color: #55ACF1;
          span{
            font-size: 12px;
          }
        }
      }
      .echarts-bar-line{
        width: 92%;
        height: 92%;
        min-width: 800px;
        min-height: 600px;
        margin: 50px auto 0;
      }
      .text{
        text-align: left;
        padding-left: 80px;
        p{
          line-height: 22px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/custom/page/huaao/visualReport/branch-outstanding-pass.vue